import styles from './DocumentsExplorer.module.scss';
import { useState } from 'react';
import { IDocument } from '../../../../../models/document';
import useApiQuery from '../../../../../Api/useApiQuery';
import DocumentsTableList from '../../Pages/Documents/Components/DocumentTableList';
import FileUpload from '../../../../../Components/FileUploadForm';

export interface DocumentsExplorerProps {
  savId: number;
  hideIds?: number[];
  selectedDocuments?: IDocument[];
  hideSelectedDocuments?: boolean;
  onChangeSelectedDocuments?: (documents: IDocument[]) => void;
}

export default function DocumentsExplorer({
  savId,
  hideIds,
  selectedDocuments = [],
  onChangeSelectedDocuments
}: DocumentsExplorerProps) {

  const [documentType, setDocumentType] = useState<'internal' | 'beneficiary'>('internal');

  const { data: dataBeneficiary } = useApiQuery<IDocument[]>('/sav/' + savId + '/documents');
  const { data: dataInternal, refetch } = useApiQuery<IDocument[]>('/sav/' + savId + '/documents', {
    params: {
      internal: true
    }
  });

  const action = (document: IDocument) => {
    return {
      label: (selectedDocuments || []).find(selectedDocument => selectedDocument.id === document.id) ? 'Désélectionner' : 'Selectionner',
      onClick: async (document: IDocument) => {
        if (selectedDocuments.find(selectedDocument => selectedDocument.id === document.id)) {
          onChangeSelectedDocuments?.(selectedDocuments.filter(selectedDocument => selectedDocument.id !== document.id));
        } else {
          onChangeSelectedDocuments?.([...(selectedDocuments || []), document]);
        }
      }
    }
  }

  return (
    <div className={styles.container}>
      {/* Display tabs with  */}
      <ul className="nav nav-tabs">
        <li className="nav-item" onClick={() => setDocumentType('internal')}>
          <a className={["nav-link", documentType === 'internal' ? "active" : ""].join(" ")} aria-current="page" href="#">Documents internes</a>
        </li>
        <li className="nav-item" onClick={() => setDocumentType('beneficiary')}>
          <a className={["nav-link", documentType === 'beneficiary' ? "active" : ""].join(" ")} href="#">Documents partagés avec le bénéficiaire</a>
        </li>
      </ul>

      {/* Display the corresponding list */}
      {documentType === 'internal' && (
        <>

          <div className='tw-flex tw-flex-col tw-items-flex-start tw-mt-4 tw-border tw-border-gray-200 tw-rounded-md tw-p-4 tw-mb-4 tw-shadow-md'>
            <div>Ajouter un document interne</div>
            <FileUpload
              uploadPath={"/sav/" + savId + "/documents/upload"}
              onUploadSuccess={() => {
                refetch();
              }}
              customData={{
                isInternal: true
              }}
            />
          </div>

          <DocumentsTableList
            data={(dataInternal || []).filter(document => !hideIds?.includes(document.id))}
            actions={[
              action
            ]}
          />
        </>
      )}

      {documentType === 'beneficiary' && (
        <DocumentsTableList
          data={(dataBeneficiary || []).filter(document => !hideIds?.includes(document.id))}
          actions={[
            action
          ]}
        />
      )}
    </div>
  )
}